module.exports = __webpack_public_path__ + "static/media/6.0e15b3bb.png";